import { redux } from 'zustand/middleware';
import { create } from 'zustand';
import reducer from '@/store/reducer';

export const initialState = {
	actionItems: [],
	actionCategories: {},
	videoModalOpen: false,
	currentVideoModalItem: null,
	learnMoreDialogOpen: false,
	currentLearnMoreDialogItem: null,
};

const useStore = create( redux( reducer, initialState ) );

export default useStore;
